var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Essentials/archive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 6",
    d: "M14.1667 2.53198V8.50519C14.1667 8.99077 14.1667 9.23356 14.0654 9.36739C13.9772 9.48399 13.8424 9.55614 13.6965 9.56485C13.5289 9.57485 13.3269 9.44018 12.9229 9.17083L12.1104 8.62917C11.95 8.52225 11.8699 8.46879 11.7832 8.44802C11.7066 8.42967 11.6267 8.42967 11.5501 8.44802C11.4635 8.46879 11.3833 8.52225 11.2229 8.62917L10.4104 9.17083C10.0064 9.44018 9.80438 9.57485 9.63687 9.56485C9.49093 9.55614 9.35611 9.48399 9.26791 9.36739C9.16667 9.23356 9.16667 8.99077 9.16667 8.50519V2.5M9.16667 2.5H7.83333C5.96649 2.5 5.03307 2.5 4.32003 2.86331C3.69282 3.18289 3.18289 3.69282 2.86331 4.32003C2.5 5.03307 2.5 5.96649 2.5 7.83333V12.1667C2.5 14.0335 2.5 14.9669 2.86331 15.68C3.18289 16.3072 3.69282 16.8171 4.32003 17.1367C5.03307 17.5 5.96649 17.5 7.83333 17.5H12.1667C14.0335 17.5 14.9669 17.5 15.68 17.1367C16.3072 16.8171 16.8171 16.3072 17.1367 15.68C17.5 14.9669 17.5 14.0335 17.5 12.1667V7.83333C17.5 5.96649 17.5 5.03307 17.1367 4.32003C16.8171 3.69282 16.3072 3.18289 15.68 2.86331C15.1338 2.58504 14.4584 2.51991 13.3333 2.50466C12.9895 2.5 12.6037 2.5 12.1667 2.5H10H9.16667Z",
    stroke: "#525D6A",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.6a91218e88d1587fd61bcb4b504004dc.svg";
export { ForwardRef as ReactComponent };